import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDefinedCategorySelector } from './components/user-defined-category-selector/user-defined-category-selector.component';
import { CoreModule } from '@abp/ng.core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BaseSelectorModule } from '../base-selector/base-selector.module';
import { CategorySelectorComponent } from './components/category-selector/category-selector.component';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginatorModule } from '@angular/material/paginator';
import { QueryEditorModule } from 'src/app/query-editor/query-editor.module';

export { UserDefinedCategorySelector } from './components/user-defined-category-selector/user-defined-category-selector.component';

@NgModule({
  declarations: [UserDefinedCategorySelector, CategorySelectorComponent],
  imports: [
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    MatPaginatorModule,
    BaseSelectorModule,
    NgbTooltipModule,
    NgbPopoverModule,
    QueryEditorModule,
  ],
  exports: [UserDefinedCategorySelector, CategorySelectorComponent],
})
export class CategorySelectorModule {}
